import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { getSize } from '@lib/common';
import { QuestionType } from '@module/form';
import styled from '@xstyled/styled-components';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledQuestionTypeTag = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: flex-start;\n\n  gap: ", ";\n\n  font-size: ", ";\n  font-weight: 600;\n  color: #728096;\n  border-radius: 999px;\n  border: 1px solid #e5e7eb;\n  padding: 6px ", ";\n  line-height: 1rem;\n"])), getSize('padding8'), getSize('typo14'), getSize('padding8'));
export var QuestionTypeTagComponent = function QuestionTypeTagComponent(_ref) {
  var questionType = _ref.questionType,
      icon = _ref.icon,
      label = _ref.label;
  var questionTypeLabel = useMemo(function () {
    var _questionTypeTagLabel;

    var questionTypeTagLabelMapping = (_questionTypeTagLabel = {}, _defineProperty(_questionTypeTagLabel, QuestionType.SingleChoice, label.singleChoiceQuestion), _defineProperty(_questionTypeTagLabel, QuestionType.MultipleChoice, label.multipleChoiceQuestion), _defineProperty(_questionTypeTagLabel, QuestionType.FillInBlank, label.fillInBlankQuestion), _defineProperty(_questionTypeTagLabel, QuestionType.Matching, label.matchingQuestion), _defineProperty(_questionTypeTagLabel, QuestionType.Essay, label.essayQuestion), _questionTypeTagLabel);
    return questionTypeTagLabelMapping[questionType] || 'Unknown';
  }, [questionType, label]);
  return /*#__PURE__*/_jsxs(StyledQuestionTypeTag, {
    children: [icon === null || icon === void 0 ? void 0 : icon.pointFocus, /*#__PURE__*/_jsx("span", {
      children: questionTypeLabel
    })]
  });
};